var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youtube-button"},[_c('a',{attrs:{"href":"https://www.youtube.com/@fushimi243","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("伏見嘉洋のYouTubeチャンネルを見る")])])
}]

export { render, staticRenderFns }